import { PanelLeft, PanelsTopLeft } from 'lucide-react';
import { useActiveEditor } from '@/store/editorContext';

export type EditorViewMode = 'document' | 'side-by-side';

export default function EditorViewTabs({
  value,
  onChange,
}: {
  value: EditorViewMode;
  onChange: (value: EditorViewMode) => void;
}) {
  const { setProductPickerTableId } = useActiveEditor();
  const select = (next: EditorViewMode) => {
    setProductPickerTableId(null);
    onChange(next);
  };
  return (
    <div
      role="group"
      aria-label="Editorweergave"
      className="workspace-view-tabs"
      data-workspace-controls
    >
      <button type="button" aria-pressed={value === 'document'} onClick={() => select('document')}>
        <PanelLeft size={15} />
        Document
      </button>
      <button
        type="button"
        aria-pressed={value === 'side-by-side'}
        onClick={() => select('side-by-side')}
      >
        <PanelsTopLeft size={15} />
        Side by side
      </button>
    </div>
  );
}
